import React, { useEffect, useState } from 'react'
import Button from './Button'
import ConfirmModal from './ConfirmModal'
import Modal from './Modal'
import { useMutation, useQuery } from '@apollo/client'
import { useTranslation } from 'react-i18next'
import SearchIcon from './icons/search'
import { RematchUnrecognized } from '../graphql/mutations'
import { GetTasks } from '../graphql/queries'

const TASK_TYPE = 'UNRECOGNIZED_REMATCH'

const RematchUnrecognizedButton = ({ onComplete }) => {

    const { t } = useTranslation()
    const [rematch, { loading: mutating }] = useMutation(RematchUnrecognized)
    const { data: tasksData, startPolling, stopPolling } = useQuery(GetTasks, {
        fetchPolicy: 'no-cache',
    })

    const [showConfirm, setShowConfirm] = useState(false)
    const [result, setResult] = useState(null)
    const [feedback, setFeedback] = useState(null)

    const isRunning = tasksData?.getTasks?.rows?.some(x => x.type === TASK_TYPE)

    useEffect(() => {
        if (isRunning || mutating) {
            startPolling(2000)
            return
        }

        stopPolling()
    }, [isRunning, mutating])

    const handleConfirm = async () => {
        setShowConfirm(false)
        startPolling(2000)

        try {
            const res = await rematch({
                refetchQueries: ['getTasks'],
            })

            const data = res?.data?.rematchUnrecognized

            if (data?.status === 'SUCCESS') {
                setResult(data)
                onComplete?.()
                return
            }

            if (data?.status === 'EXISTING') {
                setFeedback(t('unrecognized.rematch_existing'))
                return
            }

            setFeedback(t('unrecognized.rematch_failed'))
        } catch (err) {
            console.log('handleRematch: ', err)
            setFeedback(t('unrecognized.rematch_failed'))
        }
    }

    const busy = isRunning || mutating

    return (
        <>
            <Button
                label={t('unrecognized.rematch')}
                onClick={() => setShowConfirm(true)}
                disabled={busy}
                loading={busy}
                icon={busy ? null : <SearchIcon />}
            />
            <ConfirmModal
                show={showConfirm}
                confirmLabel={t('unrecognized.rematch')}
                close={() => setShowConfirm(false)}
                onConfirm={handleConfirm}
                title={t('unrecognized.confirm_rematch')}
            />
            <Modal
                show={!!result}
                close={() => setResult(null)}
                title={t('unrecognized.rematch_done')}
            >
                {result &&
                    <div className='rematch-result'>
                        <div><strong>{t('unrecognized.rematch_total')}:</strong> {result.total ?? 0}</div>
                        <div><strong>{t('unrecognized.rematch_matched')}:</strong> {result.matched ?? 0}</div>
                        <div><strong>{t('unrecognized.rematch_remaining')}:</strong> {result.remaining ?? 0}</div>
                    </div>
                }
            </Modal>
            <Modal
                show={!!feedback}
                close={() => setFeedback(null)}
                title={t('unrecognized.rematch')}
            >
                <div className='rematch-result'>{feedback}</div>
            </Modal>
        </>
    )
}

export default RematchUnrecognizedButton
